import { useState } from 'react';

import { H3 } from '@selina-finance/ui';
import mixpanel from 'mixpanel-browser';
import { useNavigate } from 'react-router-dom';

import BackButton from '@Components/BackButton/BackButton';
import { BookCallButton } from '@Components/BookCallButton';
import { BookingCalendly } from '@Components/Calendly';
import { LoanPreferencesHelp } from '@Components/Help/LoanPreferencesHelp';
import ProgressMenu from '@Components/Progress/ProgressMenu';
import { scheduleCallLoanPreferences } from '@Shared/helpers/scheduleCallLoanPreferences';

export const BookACallPageView = () => {
    const [showCalendly, setShowCalendly] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleBookCallClick = () => {
        mixpanel.track('Book a call');
        scheduleCallLoanPreferences(setShowCalendly, navigate);
    };

    const successNavLink =
        '/eligibility/loan-preferences/book-call/confirmation';

    return (
        <>
            <div className='flex flex-row justify-between'>
                <div className='flex flex-col justify-center items-center h-full mt-20 sm:mt-0'>
                    <div className='sm:w-96 w-full'>
                        <div className='hidden lg:block mb-8'>
                            <BackButton />
                        </div>
                        <H3 className='mt-4'>
                            Schedule a call with one of our qualified advisors
                        </H3>
                        <div className='text-xl mt-4'>
                            <p>
                                We need to complete your application over the
                                phone.
                            </p>
                            <p className='mt-2'>
                                Book a call with our advisors, and we’ll tailor
                                your loan to your exact needs.
                            </p>
                        </div>
                        <BookCallButton
                            color='secondary'
                            className='sm:w-96 w-full mt-8'
                            onClick={handleBookCallClick}
                        />
                        <div className='sm:hidden'>
                            <LoanPreferencesHelp />
                        </div>
                    </div>
                </div>
                <ProgressMenu />
            </div>

            {showCalendly && (
                <BookingCalendly
                    successNavLink={successNavLink}
                    onClose={() => setShowCalendly(false)}
                />
            )}
        </>
    );
};
